






import { Component, Mixins } from 'vue-property-decorator'
import CookieConsentMixin from '../mixins/CookieConsentMixin'
import CookieConsentCgu from '@/components/CookieConsentCgu.vue'

@Component({
  components: {
    CookieConsentCgu
  }
})
export default class CookieConsentCguModal extends Mixins(CookieConsentMixin) {
  loading = false

  sendHeight () {
    this.$nextTick(() => {
      const height = (this.$refs.iframe as Vue & { clientHeight: number }).clientHeight
      window.parent.postMessage({ id: 'cookie-cgu-height', value: height }, '*')
    })
  }

  async mounted () {
    this.sendHeight()
  }
}
